import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserGeneralRecord } from '@libs/shared/api';
import {
  AvatarComponent,
  AvatarSize,
} from '@libs/shared/ui/avatar/avatar.component';
import { AvatarFileKeyPipe } from '@libs/shared/utils/pipe/avatar-file-key/avatar-file-key.pipe';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [AvatarComponent, AvatarFileKeyPipe],
  template: `
    <app-avatar
      [imageFileKey]="user | avatarFileKey"
      [tooltip]="user.nickname"
      [avatarSize]="avatarSize"
      [showMenstruation]="showMenstruation" />
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  @Input() user: UserGeneralRecord;
  @Input() avatarSize: AvatarSize = 'sm';
  @Input() showMenstruation = false;
}
